//////////////////////////////////////////////////////////////////////
///     Este componente foi modificado do original do tema.        ///
///     É basicamente igual só removendo/alterando algumas partes. ///
///     Checar novas versões manualmente.                          ///
//////////////////////////////////////////////////////////////////////

import React, { Component } from "react";
import PropTypes from "prop-types";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

// We've created this component so we can have a ref to the wrapper of the links that appears in our sidebar.
// This was necessary so that we could initialize PerfectScrollbar on the links.
// There might be something with the Hidden component from material-ui, and we didn't have access to
// the links, and couldn't initialize the plugin.
class SidebarWrapper extends Component {
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      this.ps = new PerfectScrollbar(this.sidebarWrapper, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      this.ps.destroy();
    }
  }
  render() {
    const { className, user, headerLinks, links } = this.props;
    return (
      <div className={className} ref={node => this.sidebarWrapper = node}>
        {user}
        {headerLinks}
        {links}
      </div>
    );
  }
}

SidebarWrapper.propTypes = {
  className: PropTypes.string.isRequired,
  headerLinks: PropTypes.node,
  links: PropTypes.node,
  user: PropTypes.node,
};

export default SidebarWrapper;



// WEBPACK FOOTER //
// ./src/components/EnergyCompany/Sidebar/SidebarWrapper.jsx